import React, { useEffect, useState, Component } from 'react';
// The App component's contents are currently a placeholder — please update this file first for a new design / component!
import { BrowserRouter as Router, Routes, Route, NavLink, useLocation } from 'react-router-dom';
import Header from './components/Header';
import SpotifyPlayer from './components/SpotifyPlayer';
import Biography from './components/Biography';
import Home from './components/Home';
import Visualisers from './components/Visualisers';
import ImageGallery from './components/ImageGallery';
import Lyrics from './components/Lyrics';
import Live from './components/Live';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';
import UniverseExplorer from './components/UniverseExplorer';
import MerchPreview from './components/MerchPreview';
import FanConnection from './components/FanConnection';
import Timeline from './components/Timeline';
import ParticleBackground from './components/ParticleBackground';
import FuturisticCursor from './components/FuturisticCursor';
import PageTransition from './components/PageTransition';
import ScrollToAnchor from './components/ScrollToAnchor';
import BackButton from './components/BackButton';
import ListenNow from './components/ListenNow';
import { SpotifyProvider } from './components/SpotifyContext';
// Custom hook to get current location
const useCurrentLocation = () => {
  const location = useLocation();
  return location.pathname;
};
// Component to conditionally render the Spotify Player
const ConditionalSpotifyPlayer = ({
  showPlayer,
  setShowPlayer
}) => {
  const currentPath = useCurrentLocation();
  // Hide the player when on the ListenNow page
  if (currentPath === '/listen') {
    return null;
  }
  return <>
      {!showPlayer && <button onClick={() => setShowPlayer(true)} className="mx-auto flex items-center justify-center py-2 px-4 bg-gradient-to-r from-pink-600 to-purple-600 text-white rounded-t-lg transition-all duration-300 transform hover:translate-y-1 group shadow-lg shadow-pink-500/20" data-id="element-0">
          <span className="relative overflow-hidden group-hover:glitch" data-id="element-1">
            LISTEN ON SPOTIFY
            <span className="absolute top-0 left-0 w-full h-full bg-pink-500/20 opacity-0 group-hover:opacity-100 transform -translate-x-full group-hover:translate-x-0 transition-all duration-500" data-id="element-2"></span>
          </span>
        </button>}
      {showPlayer && <SpotifyPlayer onClose={() => setShowPlayer(false)} data-id="element-3" />}
    </>;
};
// ScrollToTop component to handle route changes
const ScrollToTop = () => {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
export function App() {
  const [showPlayer, setShowPlayer] = useState(false);
  const [currentPage, setCurrentPage] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    const handleRouteChange = () => {
      setCurrentPage(window.location.pathname);
    };
    window.addEventListener('popstate', handleRouteChange);
    handleRouteChange();
    return () => {
      window.removeEventListener('popstate', handleRouteChange);
    };
  }, []);
  const openSpotifyPlayer = () => {
    setShowPlayer(true);
  };
  if (isLoading) {
    return <div className="fixed inset-0 bg-black flex items-center justify-center z-50" data-id="element-4">
        <div className="text-center" data-id="element-5">
          <h1 className="text-6xl font-bold tracking-wider text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-purple-500 font-mono mb-4 animate-pulse" data-id="element-6">
            FABRIC REALITY
          </h1>
          <div className="w-48 h-1 bg-gradient-to-r from-pink-500 to-purple-500 mx-auto rounded-full" data-id="element-7">
            <div className="h-full w-1/3 bg-white rounded-full animate-[loading_1.5s_ease-in-out_infinite]" data-id="element-8"></div>
          </div>
        </div>
      </div>;
  }
  return <Router data-id="element-9">
      <SpotifyProvider openPlayer={openSpotifyPlayer} data-id="element-10">
        <ScrollToTop data-id="element-11" />
        <FuturisticCursor data-id="element-12" />
        <ScrollToAnchor data-id="element-13" />
        <div className="flex flex-col min-h-screen w-full bg-black text-white relative overflow-x-hidden" data-id="element-14">
          <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-15">
            {/* Cosmic background with gradients instead of image */}
            <div className="absolute inset-0 bg-gradient-to-b from-indigo-950 via-purple-950 to-black" data-id="element-16"></div>
            {/* Animated nebula effect */}
            <div className="absolute inset-0 opacity-30 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-purple-700/30 via-transparent to-transparent animate-pulse" data-id="element-17"></div>
            <div className="absolute inset-0 opacity-20 bg-[radial-gradient(ellipse_at_bottom_right,_var(--tw-gradient-stops))] from-pink-700/30 via-transparent to-transparent animate-pulse" style={{
            animationDelay: '1s'
          }} data-id="element-18"></div>
            <ParticleBackground data-id="element-19" />
            <div className="stars absolute inset-0" data-id="element-20"></div>
          </div>
          <div className="relative z-10 flex flex-col min-h-screen" data-id="element-21">
            <Header data-id="element-22" />
            <BackButton data-id="element-23" />
            <PageTransition data-id="element-24">
              <main className="flex-grow container mx-auto px-4 sm:px-6 py-12" data-id="element-25">
                <Routes data-id="element-26">
                  <Route path="/" element={<Home data-id="element-28" />} data-id="element-27" />
                  <Route path="/biography" element={<Biography data-id="element-30" />} data-id="element-29" />
                  <Route path="/visualisers" element={<Visualisers data-id="element-32" />} data-id="element-31" />
                  <Route path="/images" element={<ImageGallery data-id="element-34" />} data-id="element-33" />
                  <Route path="/lyrics" element={<Lyrics data-id="element-36" />} data-id="element-35" />
                  <Route path="/live" element={<Live data-id="element-38" />} data-id="element-37" />
                  <Route path="/universe" element={<UniverseExplorer data-id="element-40" />} data-id="element-39" />
                  <Route path="/merch" element={<MerchPreview data-id="element-42" />} data-id="element-41" />
                  <Route path="/connect" element={<FanConnection data-id="element-44" />} data-id="element-43" />
                  <Route path="/timeline" element={<Timeline data-id="element-46" />} data-id="element-45" />
                  <Route path="/listen" element={<ListenNow data-id="element-48" />} data-id="element-47" />
                </Routes>
              </main>
            </PageTransition>
            <div className="sticky bottom-0 z-50 w-full" data-id="element-49">
              <ConditionalSpotifyPlayer showPlayer={showPlayer} setShowPlayer={setShowPlayer} data-id="element-50" />
            </div>
            <div id="newsletter" data-id="element-51">
              <Newsletter data-id="element-52" />
            </div>
            <Footer data-id="element-53" />
          </div>
        </div>
      </SpotifyProvider>
    </Router>;
}